import { Box } from "@mui/material";
import Lottie from "lottie-react";
import loadingDashCircle from "./loadingDashCircle.json";
import styles from "./index.module.css";

type CoreSpinnerProps = {
	/** The size of the component in px. @default 40 */
	size?: number | string;
	className?: string;
};

export function CoreSpinner({ size, className }: CoreSpinnerProps) {
	const circleSize = size ?? "40px";

	return (
		<Box width={circleSize} height={circleSize} role="status" aria-live="polite" aria-busy="true" className={className}>
			<Lottie animationData={loadingDashCircle} />
		</Box>
	);
}

/**Centers core spinner on the page */
export function CoreLoadingPage({ ...props }: CoreSpinnerProps) {
	return (
		<div className={styles.coreSpinnerContainer}>
			<CoreSpinner {...props} />
		</div>
	);
}
